export enum EDiscountType {
  Percentage,
  Dollars,
}
